import type {FontFamily} from "../types";

export const fontFamily: FontFamily = {
    primary: "Roboto",
    secondary: "ATGRubrik",
};
